export const HIGHLIGHTED_PICKERS_VARIANTS = {
  info: 'info',
  accent: 'accent',
}
